import { createSelector } from '@reduxjs/toolkit';

/**
 *
 * @param state
 * @return {[ExtensionState]} extensions slice
 */
const getExtensions = (state) => state.extensions;
const isDisplayable = ({ allowed, consumable, enabled }) =>
  allowed && consumable && enabled;
const isFetchRequired = ({ fetch, src }) => fetch === 'idle' && Boolean(src);
const isRegisterRequired = ({
  allowed,
  error,
  fetch,
  consumable,
  ..._rest
}) => {
  const noErrors = Boolean(error) === false;
  const isFetched = fetch === 'fulfilled';
  const notYetRegister = consumable === false;

  return noErrors && isFetched && notYetRegister;
};

const displayableExtensions = createSelector(getExtensions, (extensions) =>
  extensions.filter(isDisplayable),
);
const requiredToFetch = createSelector(getExtensions, (extensions) =>
  extensions.filter(isFetchRequired),
);
const requiredToRegister = createSelector(getExtensions, (extensions) =>
  extensions.filter(isRegisterRequired),
);
const getDisplayableExtension = createSelector(
  [displayableExtensions, (_state, extensionName) => extensionName],
  (extensionList, extensionName) =>
    extensionList.find(({ name }) => name === extensionName),
);
export {
  getExtensions,
  displayableExtensions,
  requiredToFetch,
  requiredToRegister,
  getDisplayableExtension,
};
